const e = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, o = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SCREENS: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  e as S,
  o as s
};
